export const shipTostatuses = {
  Closed: 'closed',
};

export const isShipToNameClosed = (shipToName) => shipToName?.trim().toLowerCase().startsWith(shipTostatuses.Closed);